import { DEALERS_API_URL, USER_GROUPS_API_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

/**
 * @param {string} dealerId
 * @param {Object} params
 */
export const getUserGroups = (dealerId, params) => ({
  type: types.FETCH_USER_GROUPS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${USER_GROUPS_API_URL}`,
      params: {
        dealerId,
        projection: 'details',
        status: 'open',
        sort: 'order,asc',
        ...params,
      },
    },
  },
  meta: { dealerId },
});

export const getUserGroupsSuccess = (data, meta) => ({
  type: types.FETCH_USER_GROUPS_SUCCESS,
  payload: data,
  meta,
});

export const getUserGroupsFailure = error => ({
  type: types.FETCH_USER_GROUPS_FAILURE,
  payload: error,
  error: true,
});

/**
 *
 * @param {string} dealerId
 * @param {import('../types/public-user-group').PublicUserGroup} data
 * @param {Object} [meta={}]
 * @returns {import('../types/actions').UpdateUserGroupsAction}
 */
export const updateUserGroups = (dealerId, data, meta = {}) => ({
  type: types.UPDATE_USER_GROUPS_REQUEST,
  payload: {
    request: {
      method: 'PUT',
      url: `${DEALERS_API_URL}/${dealerId}/userGroups`,
      data,
    },
  },
  meta: { ...meta, dealerId },
});

/**
 * @param {import('../types/public-user-group').PublicUserGroup} data
 * @param {Object} [meta={}]
 * @returns {import('../types/actions').UpdateUserGroupsSuccessAction}
 */
export const updateUserGroupsSuccess = (data, meta = {}) => ({
  type: types.UPDATE_USER_GROUPS_SUCCESS,
  payload: data,
  meta,
});

/**
 * @param {string} error
 * @returns {import('../types/actions').UpdateUserGroupsFailureAction}
 */
export const updateUserGroupsFailure = error => ({
  type: types.UPDATE_USER_GROUPS_FAILURE,
  payload: error,
  error: true,
});

export const fetchUserGroupsByDealerIds = ({ dealerIds, pageNumber: page = 0, search }) => ({
  type: types.FETCH_SELECTED_USER_GROUPS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: '/userGroups/filter',
      params: {
        dealerIds,
        projection: 'page',
        sort: 'dealerId,asc',
        text: search,
        page,
        status: 'open',
      },
    },
    search,
    page,
  },
});

export const fetchUserGroupsByDealerIdsSuccess = data => ({
  type: types.FETCH_SELECTED_USER_GROUPS_SUCCESS,
  payload: data,
});

export const fetchUserGroupsByDealerIdsFailure = error => ({
  type: types.FETCH_SELECTED_USER_GROUPS_FAILURE,
  payload: error,
  error: true,
});

export const clearUserGroupSelect = () => ({
  type: types.CLEAR_USER_GROUP_SELECT,
});
